/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Bar_All_Caught_UpInputs */



/**
* | output |
* | --- |
* | "All caught up" |
*
* @param {Activity_Bar_All_Caught_UpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_bar_all_caught_up = /** @type {((inputs?: Activity_Bar_All_Caught_UpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Bar_All_Caught_UpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alles erledigt")
	return /** @type {LocalizedString} */ ("All caught up")
});